// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weather {
    width: 300px;
    border-radius: 6px;
    box-shadow: 10px -2px 20px 2px rgb(0 0 0 / 30%);
    color: #fff;
    background-color: #333;
    margin: 20px auto 0 auto;
    padding: 0 20px 20px 20px;
  }
  
  .top,
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .city {
    font-weight: 600;
    font-size: 18px;
    line-height: 1;
    margin: 0;
    letter-spacing: 1px;
  }
  
  .weather-description {
    font-weight: 400;
    font-size: 14px;
    line-height: 1;
    margin: 0;
  }
  
  .weather-icon {
    width: 100px;
  }
  
  .temperature {
    font-weight: 600;
    font-size: 70px;
    width: auto;
    letter-spacing: -5px;
    margin: 10px 0;
  }
  
  .details {
    width: 100%;
    padding-left: 20px;
  }
  
  .parameter-row {
    display: flex;
    justify-content: space-between;
  }
  
  .parameter-label {
    text-align: left;
    font-weight: 400;
    font-size: 12px;
  }
  
  .parameter-value {
    text-align: right;
    font-weight: 600;
    font-size: 12px;
  }
  
  .parameter-label.top {
    border-bottom: 1px solid #fff;
  }`, "",{"version":3,"sources":["webpack://./src/components/current-weather/current-weather.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,+CAA+C;IAC/C,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B","sourcesContent":[".weather {\n    width: 300px;\n    border-radius: 6px;\n    box-shadow: 10px -2px 20px 2px rgb(0 0 0 / 30%);\n    color: #fff;\n    background-color: #333;\n    margin: 20px auto 0 auto;\n    padding: 0 20px 20px 20px;\n  }\n  \n  .top,\n  .bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .city {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 1;\n    margin: 0;\n    letter-spacing: 1px;\n  }\n  \n  .weather-description {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1;\n    margin: 0;\n  }\n  \n  .weather-icon {\n    width: 100px;\n  }\n  \n  .temperature {\n    font-weight: 600;\n    font-size: 70px;\n    width: auto;\n    letter-spacing: -5px;\n    margin: 10px 0;\n  }\n  \n  .details {\n    width: 100%;\n    padding-left: 20px;\n  }\n  \n  .parameter-row {\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .parameter-label {\n    text-align: left;\n    font-weight: 400;\n    font-size: 12px;\n  }\n  \n  .parameter-value {\n    text-align: right;\n    font-weight: 600;\n    font-size: 12px;\n  }\n  \n  .parameter-label.top {\n    border-bottom: 1px solid #fff;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
